import React from "react";
import axios from "axios";
import Q1Table from "../../thread/multiple-table";
import Q2Table from "../../thread/blank-table";
import Q3Table from "../../thread/true-false-table";
import MuiAlert from "@material-ui/lab/Alert";
import { Snackbar } from "@material-ui/core";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class PhonemeTrainPart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      q1: [],
      q2: [],
      q3: [],
      q1Index: 0,
      q2Index: 0,
      q3Index: 0,
      q1Score: 0,
      q2Score: 0,
      q3Score: 0,
      q1Assign: [],
      q2Assign: [],
      q3Assign: [],
      q_show: 1,
      numOfQuestions: 0,
      alert: false,
      version: null
    };
  }

  componentDidMount = async () => {
    const doc = await axios.get(
      "/api/literacy/phoneme/student/progress/" + this.props.id
    );
    const {
      q1Score,
      q2Score,
      q3Score,
      q1Assign,
      q2Assign,
      q3Assign,
      q1Index,
      q2Index,
      q3Index,
      q1Questions,
      q2Questions,
      q3Questions,
      numOfQuestions,
      version
    } = doc.data;
    if (q3Assign.length !== 0) {
      this.setState({
        q1Score,
        q2Score,
        q3Score,
        q1Assign,
        q2Assign,
        q3Assign,
        q1Index,
        q2Index,
        q3Index,
        q_show: 3,
        numOfQuestions,
        version
      });
    } else if (q2Assign.length !== 0) {
      this.setState({
        q1Score,
        q2Score,
        q1Assign,
        q2Assign,
        q1Index,
        q2Index,
        q_show: 2,
        numOfQuestions,
        version
      });
    } else {
      this.setState({
        q1Score,
        q1Assign,
        q_show: 1,
        q1Index,
        numOfQuestions,
        version
      });
    }
    this.setState({ q1: q1Questions, q2: q2Questions, q3: q3Questions });
  };

  handleSaveAssignment = async () => {
    const {
      q1,
      q2,
      q3,
      q1Score,
      q2Score,
      q3Score,
      q1Assign,
      q2Assign,
      q3Assign,
      q1Index,
      q2Index,
      q3Index,
      numOfQuestions
    } = this.state;
    // 1. Clean the student last progress and delete the old progress
    const doc1 = await axios.put("/api/literacy/phoneme/student/progress", {
      newProgress: "",
      version: this.state.version
    });
    if (doc1.data !== "") {
      await axios.delete("/api/literacy/phoneme/student/progress/" + doc1.data);
    }

    // 2. save progress into database and save progress_id into student database
    const doc2 = await axios.post("/api/literacy/phoneme/student/progress", {
      q1Score,
      q2Score,
      q3Score,
      q1Assign,
      q2Assign,
      q3Assign,
      q1Index,
      q2Index,
      q3Index,
      q1Questions: q1,
      q2Questions: q2,
      q3Questions: q3,
      numOfQuestions,
      version: this.state.version
    });
    await axios.put("/api/literacy/phoneme/student/progress", {
      newProgress: doc2.data._id,
      version: this.state.version
    });
    // show alert bar
    this.setState({ alert: true });
  };

  handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") return;
    this.setState({ alert: false });
  };

  handleSubmit = async (q3Score, q3Assign) => {
    const { q1Score, q2Score, q1Assign, q2Assign, version, numOfQuestions } = this.state;
    const newScore = q1Score + q2Score + q3Score;
    await axios.post("/api/literacy/phoneme/assign", {
      newScore,
      q1Assign,
      q2Assign,
      q3Assign,
      version
    });
    await axios.put("/api/literacy/phoneme/score", { newScore });
    window.location = "/literacy/student/phoneme";
  };

  handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") return;
    this.setState({ alert: false });
  };

  renderQuestion = () => {
    const {
      q_show,
      q1,
      q2,
      q3,
      q1Assign,
      q2Assign,
      q3Assign,
      q1Index,
      q2Index,
      q3Index,
      q1Score,
      q2Score,
      q3Score
    } = this.state;
    switch (q_show) {
      case 1:
        return (
          <Q1Table
            rows={q1}
            assignment={q1Assign}
            index={q1Index}
            backURL="/literacy/student/phoneme/assignment"
            handleSaveAssignment={(index, questions, assign, score) => {
              this.setState(
                {
                  q1Index: index,
                  q1: questions,
                  q1Score: score ?? 0,
                  q1Assign: assign,
                },
                this.handleSaveAssignment
              );
            }}
            handleNext={(q1Assign) =>
              this.setState({ q1Score, q1Assign, q_show: q_show + 1 })
            }
          />
        );
      case 2:
        return (
          <Q2Table
            rows={q2}
            assignment={q2Assign}
            index={q2Index}
            score={q2Score}
            backURL="/literacy/student/phoneme/assignment"
            handleSaveAssignment={(index, questions, assign, score) => {
              this.setState(
                {
                  q2Index: index,
                  q2: questions,
                  q2Score: score ?? 0,
                  q2Assign: assign,
                },
                this.handleSaveAssignment
              );
            }}
            handleNext={(q2Score, q2Assign) =>
              this.setState({ q2Score, q2Assign, q_show: q_show + 1 })
            }
          />
        );
      case 3:
        return (
          <Q3Table
            rows={q3}
            assignment={q3Assign}
            index={q3Index}
            score={q3Score}
            backURL="/literacy/student/phoneme/assignment"
            handleSaveAssignment={(index, questions, assign, score) => {
              this.setState(
                {
                  q3Index: index,
                  q3: questions,
                  q3Score: score ?? 0,
                  q3Assign: assign,
                },
                this.handleSaveAssignment
              );
            }}
            handleNext={(q3Score, q3Assign) =>
              this.handleSubmit(q3Score, q3Assign)
            }
          />
        );
      default:
        return null;
    }
  };

  render() {
    const { q1 } = this.state;
    return (
      <div>
        {!!q1.length ? this.renderQuestion() : null}
        <Snackbar
          open={this.state.alert}
          autoHideDuration={2000}
          onClose={this.handleCloseAlert}
        >
          <Alert onClose={this.handleClose} severity="success">
            Saved Successfully!
          </Alert>
        </Snackbar>
      </div>
    );
  }
}

export default PhonemeTrainPart;
